export default "__VITE_ASSET__$iVHl8ki__"